module.exports = __webpack_public_path__ + "img/peace-japanese2.c41d7f4e.png";